//metodo para la data de pagina siguiente
export const getDataNext = (firebase, pageSize, initValue, text) => {
  return new Promise(async (resolve, reject) => {
    let estatesList = firebase.db
      .collection("Estates")
      //codigo añadido despues del login por telefono
      //filtra los estates por el usuario actual - currentUser de la BBDD
      .where("owner", "==", firebase.auth.currentUser.uid)
      .orderBy("direction")
      .limit(pageSize);

    console.log(initValue);
    console.log(pageSize);

    if (initValue !== null) {
      estatesList = firebase.db
        .collection("Estates")
        //codigo añadido despues del login por telefono
        //filtra los estates por el usuario actual - currentUser de la BBDD
        .where("owner", "==", firebase.auth.currentUser.uid)
        .orderBy("direction")
        .startAfter(initValue)
        .limit(pageSize);

      if (text.trim() !== "") {
        estatesList = firebase.db
          .collection("Estates")
          //codigo añadido despues del login por telefono
          //filtra los estates por el usuario actual - currentUser de la BBDD
          .where("owner", "==", firebase.auth.currentUser.uid)
          .orderBy("direction")
          .where("keywords", "array-contains", text.toLowerCase())
          .startAfter(initValue)
          .limit(pageSize);
      }
    }
    //llamada al query estates y extraccion de la data de la bbdd
    const snapshot = await estatesList.get();
    const arrayEstates = snapshot.docs.map(doc => {
      let data = doc.data();
      let id = doc.id;
      //objeto estateList
      return { id, ...data };
    });
    //capturamos el primer elemento del array que me devuelve la bbdd
    const initialData = snapshot.docs[0];
    //capturamos el primer elemento del array que me devuelve la bbdd
    const finallyData = snapshot.docs[snapshot.docs.length - 1];
    //json que retorna la data
    const returnData = {
      arrayEstates,
      initialData,
      finallyData
    };
    //devolvemos la respuesta de la promesa
    resolve(returnData);
  });
};

//metodo para la data de pagina anterior
export const getDataBefore = (firebase, pageSize, initValue, text) => {
  return new Promise(async (resolve, reject) => {
    let estatesList = firebase.db
      .collection("Estates")
      //codigo añadido despues del login por telefono
      //filtra los estates por el usuario actual - currentUser de la BBDD
      .where("owner", "==", firebase.auth.currentUser.uid)
      .orderBy("direction")
      .limit(pageSize);

    //console.log(initValue);
    //console.log(pageSize);

    if (initValue !== null) {
      estatesList = firebase.db
        .collection("Estates")
        //codigo añadido despues del login por telefono
        //filtra los estates por el usuario actual - currentUser de la BBDD
        .where("owner", "==", firebase.auth.currentUser.uid)
        .orderBy("direction")
        .startAt(initValue)
        .limit(pageSize);

      if (text.trim() !== "") {
        estatesList = firebase.db
          .collection("Estates")
          //codigo añadido despues del login por telefono
          //filtra los estates por el usuario actual - currentUser de la BBDD
          .where("owner", "==", firebase.auth.currentUser.uid)
          .orderBy("direction")
          .where("keywords", "array-contains", text.toLowerCase())
          .startAt(initValue)
          .limit(pageSize);
      }
    }
    //llamada al query estates y extraccion de la data de la bbdd
    const snapshot = await estatesList.get();
    const arrayEstates = snapshot.docs.map(doc => {
      let data = doc.data();
      let id = doc.id;
      return { id, ...data };
    });
    //capturamos el primer valor del array
    const initialData = snapshot.docs[0];
    //capturamos el ultimo valor del array
    const finallyData = snapshot.docs[snapshot.docs.length - 1];
    //json que retorna la data
    const returnData = {
      arrayEstates,
      initialData,
      finallyData
    };
    //devolvemos la respuesta de la promesa
    resolve(returnData);
  });
};
